import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faq';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="defer-paint w-full bg-sand py-10 sm:py-12" aria-labelledby="faq-heading" data-id="element-48" data-mp="1bl23p9e8x8f0">
      <div className="mx-auto max-w-3xl px-6" data-id="element-49" data-mp="1gj3lzs3ul3pf">
        <div className="text-center" data-id="element-50" data-mp="1gjvjx9kx3div">
          <p className="eyebrow text-sage-deep" data-id="element-51" data-mp="249g39tkzgcso">Before you decide</p>
          <h2 id="faq-heading" className="mt-5 font-display text-[2rem] leading-[1.12] text-ink sm:text-4xl" data-id="element-52" data-mp="24baqjejq8gzx">
            Frequently asked questions
          </h2>
        </div>

        <ul className="mt-12 space-y-2.5" data-id="element-53" data-mp="1uiv86g4ipqei">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className={`rounded-3xl border bg-shell transition-colors duration-150 ease-out ${isOpen ? 'border-sage/45' : 'border-line'}`} data-id="element-54" data-mp="1zg4uhmwm1ly4" data-mpi={index}>
                <h3 data-id="element-55" data-mp="2s0brkgq8cpv6">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 rounded-3xl px-6 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sage" data-id="element-56" data-mp="2s0vb21vj3mbb">
                    <span className="font-display text-lg leading-snug text-ink sm:text-xl" data-id="element-57" data-mp="19u50hgdalfue">
                      {faq.question}
                    </span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ease-out ${isOpen ? 'bg-sage text-ivory' : 'bg-sage-light text-sage-deep'}`} aria-hidden="true" data-id="element-58" data-mp="1ol47imyhbwbv">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-59" data-mp="1skd2fv59a090" />
                    </span>
                  </button>
                </h3>

                <div id={`faq-panel-${index}`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-60" data-mp="3ucrdqbdao6gg">
                  <div className="overflow-hidden" data-id="element-61" data-mp="237oatw6dqhpa">
                    <p className="px-6 pb-6 font-sans text-[0.93rem] leading-relaxed text-stone" data-id="element-62" data-mp="23aaf9mxz4h3a">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}